
      const measurementId =
        process.env.NODE_ENV === "development" ? "G-GYN15SE904" : "G-82XSMBDYTJ";

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", measurementId);
    